export default {
  namespaced: true,
  state: {
    baseAddress: ''
  },
  getters: {
    baseAddress (state: any) {
      return state.baseAddress
    },
    fileUrl: (state: any) => (fileName: string) => {
      // Set cdn address if it is our own file and is not external
      if (!(fileName.startsWith('http://') || fileName.startsWith('https://') || fileName.startsWith('/'))) {
        return fileName = state.baseAddress + fileName
      }

      return fileName
    }
  },
  actions: {
    setBaseAddress (context: any, baseAddress: string) {
      context.commit('baseAddressLoaded', baseAddress)
    }
  },
  mutations: {
    baseAddressLoaded (state: any, baseAddress: string) {
      state.baseAddress = baseAddress
    }
  }
}
